document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.testimonial-wrapper-199126 .testimonial-track-wrapper');
    const cards = document.querySelectorAll('.testimonial-wrapper-199126 .testimonial-card');
    const prevBtn = document.querySelector('.testimonial-wrapper-199126 .carousel-btn.prev');
    const nextBtn = document.querySelector('.testimonial-wrapper-199126 .carousel-btn.next');
    const dotsContainer = document.querySelector('.testimonial-wrapper-199126 .carousel-dots');

    if (!wrapper || !cards.length) return;

    const GAP = 20;
    let index = 0;

    const cardWidth = () => cards[0].offsetWidth + GAP;

    const visibleCount = () => {
      if (window.innerWidth <= 480) return 1;
      if (window.innerWidth <= 900) return 2;
      if (window.innerWidth <= 1200) return 3;
      return 4;
    };

    const maxIndex = () => Math.max(0, cards.length - visibleCount());

    const scrollToIndex = (i) => {
      index = Math.max(0, Math.min(i, maxIndex()));
      wrapper.scrollTo({
        left: index * cardWidth(),
        behavior: 'smooth',
      });
      updateDots();
      updateArrows();
    };

    const updateArrows = () => {
      prevBtn.classList.toggle('disabled', index === 0);
      nextBtn.classList.toggle('disabled', index === maxIndex());
    };

    const createDots = () => {
      dotsContainer.innerHTML = '';
      for (let i = 0; i <= maxIndex(); i++) {
        const dot = document.createElement('button');
        dot.addEventListener('click', () => scrollToIndex(i));
        dotsContainer.appendChild(dot);
      }
    };

    const updateDots = () => {
      dotsContainer.querySelectorAll('button').forEach((dot, i) => dot.classList.toggle('active', i === index));
    };

    wrapper.addEventListener('scroll', () => {
      index = Math.round(wrapper.scrollLeft / cardWidth());
      updateDots();
      updateArrows();
    });

    nextBtn.addEventListener('click', () => scrollToIndex(index + 1));
    prevBtn.addEventListener('click', () => scrollToIndex(index - 1));

    window.addEventListener('resize', () => {
      index = 0;
      createDots();
      scrollToIndex(0);
    });

    createDots();
    scrollToIndex(0);
  });